module.exports = __webpack_public_path__ + "img/IMG_2659.7311ddd5.jpg";